export const PRODUCTS = (isCompanyAdmin = false) => ({
  NOMAD_INSURANCE: {
    name: 'nomadinsurance',
    label: 'Nomad Insurance',
    url: '/nomad-insurance/profile',
    registrationUrl: '/nomad-insurance/registration'
  },
  REMOTE_HEALTH: {
    name: 'remotehealth',
    label: 'Remote Health',
    url: isCompanyAdmin
      ? `${process.env.REACT_APP_URL}/remote-health/company`
      : `${process.env.REACT_APP_URL}/remote-health/member`,
    registrationUrl: '/rh-registration',
    external: true
  },
  NOMAD_HEALTH: {
    name: 'nomadhealth',
    label: 'Nomad Health',
    url: `${process.env.REACT_APP_URL}/nomad-health/profile`,
    registrationUrl: '/nomad-health',
    external: true
  }
});

export const nomadHealthCompanyId = 3079;
